import React from 'react'
import { Layout } from 'antd'

const { Footer } = Layout

const AppFooter = () => <Footer className='footer'>
    <a href="https://beian.miit.gov.cn" target="_blank">浙ICP备2025202225号-2</a>

</Footer>
export default AppFooter;